import { gql } from '__generated__';

export default gql(`
  mutation AddFeedback($input: AddFeedbackInput!) {
    addFeedback(input: $input) {
      id
    }
  }
`);
